import axios from "axios";

export async function getAvailableSlotsByDate(year, month, day) {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_BOOKING_ADMIN_URL}/booking/getAvailableSlots/${year}/${month}/${day}`,
      {},
      {
        headers: {
          api_key: process.env.REACT_APP_BOOKING_ADMIN_API_KEY,
        },
      }
    );
    const data = await res.json();
    return data;
  } catch (err) {
    throw err;
  }
}

export const addBooking = async (body) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BOOKING_ADMIN_URL}/booking/addBooking`,
      body,
      {
        headers: {
          api_key: process.env.REACT_APP_BOOKING_ADMIN_API_KEY,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getDailyData = async (day, month, year) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_GET_DAILY_DATA}/${year}/${month}/${day}`,
      {
        headers: {
          api_key: process.env.REACT_APP_BOOKING_ADMIN_API_KEY,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const getMonthlyData = async (year, month) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_GET_MONTHLY_DATA}/${year}/${month}`,
      {
        headers: {
          api_key: process.env.REACT_APP_BOOKING_ADMIN_API_KEY,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateBooking = async (bookingId, body) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_BOOKING_ADMIN_URL}/booking/updateBooking/${bookingId}`,
      body,
      {
        headers: {
          api_key: process.env.REACT_APP_BOOKING_ADMIN_API_KEY,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteBooking = async (bookingId) => {
  try {
    await axios.delete(
      `${process.env.REACT_APP_BOOKING_ADMIN_URL}/booking/deleteBooking/${bookingId}`,
      {
        headers: {
          api_key: process.env.REACT_APP_BOOKING_ADMIN_API_KEY,
        },
      }
    );
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getMaxBookingDate = async (tmRef) => {
  try {
    const response = await axios.post(
      process.env.REACT_APP_GET_MAX_BOOKING_DATE,
      { tmRef }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getBookingWindow = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BOOKING_ADMIN_URL}/booking/getBookingWindow`,
      { headers: { api_key: process.env.REACT_APP_BOOKING_ADMIN_API_KEY } }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const searchForBooking = async (token) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BOOKING_ADMIN_URL}/booking/getBookingByToken/${token}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const existingBookingSearch = async (customerId, phoneNumber) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BOOKING_ADMIN_URL}/booking/search`,
      { customerId, phoneNumber },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
